// extracted by mini-css-extract-plugin
export default {"showXs":"PaginationEditor_showXs__pHo6O","hideXs":"PaginationEditor_hideXs__YY6mv"};